import types from "./types";
import utils from "./utils";

export const init_state = {
  banner: {
    dissmissed: [],
    data: null,
  },
};

export default function generalReducer(state = init_state, action) {
  switch (action.type) {
    case types.SET_BANNER:
      return utils.reducer_set_banner(state, action.payload);
    case types.SET_BANNER_AS_DISSMISSED:
      return utils.reducer_set_banner_as_dissmissed(state, action.payload);
    default:
      return state;
  }
}
